export default __webpack_public_path__ + "static/media/seal2.41631300.jpeg";